import React, { useEffect, useState } from "react";
import {
    Table,
    Column,
} from '../../Common';
import Routes from '../../../routes';

const RelatedAssetsTable = ({
    assetId,
    filterOptions
}) => {
    return (
        <>
            <Table
                renderDefaultFilterInTable
                url={Routes.Asset.GetRelatedAssets(assetId)}
                filterOptions={filterOptions}
                exportButtonAlt={"Export Related Assets (.csv)"}
                exportButtonURL={Routes.Asset.ExportRelatedAssets(assetId)}
                fileName={"Related_Assets"}
                tableHeader="Related Assets"
                tableHeaderTooltipText="View connected inventory that has a relational link to the selected asset. Related assets may include linked Leak Monitoring Devices, other iterations of the selected asset (ex. Retrofitted), and system or subsystem assets that are connected through a parent or child relationship."
                noResultText="Oops...It is empty here..."
                noResultText2="Create a new Related assets or change your search criteria."
            >
                <Column id='relationshipType' title="Relationship" property="relationshipType" filter="dropdown" />
                <Column id='assetName' title="Asset Name" property="assetName" link="/Inventory/" linkId="assetId" filter="text" />
                <Column id='systemType' title="System type" property="systemType" filter="dropdown" />
                <Column id='materialType' title="Material Type" property="materialType" filter="dropdown"/>
                <Column id='serialNumber' title="Serial Number" property="serialNumber" filter="text" />
                <Column id='installDate' title="Install Date" property="installDateString" filter="date" />
                <Column id='shutdownDate' title="Shutdown Date" property="shutdownDateString" filter="date" />
            </Table>
        </>
    )
}

export default RelatedAssetsTable;